import React from 'react';
import { useSelector } from 'react-redux';
import { getUserInfoReducer } from 'reducer/common/userInfo';

const Home = () => {
  const userInfoReducer = useSelector(getUserInfoReducer);
  return (
    <>
      <h2>HOME</h2>
      <h3>登入者資訊</h3>
      <pre>{JSON.stringify(userInfoReducer, undefined, 2)}</pre>
    </>
  );
};
export default Home;
